import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

// admin routing
const AdminRallies = Loadable(lazy(() => import('views/admin/Rallies')));
const AdminRallySites = Loadable(lazy(() => import('views/admin/RallySites')));
const AdminRallySiteAdd = Loadable(lazy(() => import('views/admin/RallySiteAdd')));
const AdminRallySiteEdit = Loadable(lazy(() => import('views/admin/RallySiteEdit')));
const AdminUsers = Loadable(lazy(() => import('views/admin/Users')));
const AdminDocuments = Loadable(lazy(() => import('views/admin/Documents')));
const AdminRallyBookings = Loadable(lazy(() => import('views/admin/AdminRallyBookings')));
const AdminGDPR = Loadable(lazy(() => import('views/admin/GDPR')));
const AdminReports = Loadable(lazy(() => import('views/admin/Reports')));
const AdminGeneralSettings = Loadable(lazy(() => import('views/admin/GeneralSettings')));

// rally officer routing
const Dashboard = Loadable(lazy(() => import('views/rally-officer/Dashboard')));
const ManageBookings = Loadable(lazy(() => import('views/rally-officer/ManageBookings')));
const RallyBookings = Loadable(lazy(() => import('views/rally-officer/RallyBookings')));
const RallyOfficerDocuments = Loadable(lazy(() => import('views/rally-officer/Documents')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: '/',
      element: <Navigate to="/rally-officer/dashboard" replace />
    },
    {
      path: '/rally-officer/dashboard',
      element: <Dashboard />
    },
    {
      path: '/rally-officer/manage-bookings',
      element: <ManageBookings />
    },
    {
      path: '/rally-officer/manage-bookings/:rallyId',
      element: <RallyBookings />
    },
    {
      path: '/rally-officer/documents',
      element: <RallyOfficerDocuments />
    },
    {
      path: '/admin/rallies',
      element: <AdminRallies />
    },
    {
      path: '/admin/rally/:rallyId/bookings',
      element: <AdminRallyBookings />
    },
    {
      path: '/admin/rally-sites',
      element: <AdminRallySites />
    },
    {
      path: '/admin/rally-sites/add',
      element: <AdminRallySiteAdd />
    },
    {
      path: '/admin/rally-sites/edit/:id',
      element: <AdminRallySiteEdit />
    },
    {
      path: '/admin/users',
      element: <AdminUsers />
    },
    {
      path: '/admin/documents',
      element: <AdminDocuments />
    },
    {
      path: '/admin/gdpr',
      element: <AdminGDPR />
    },
    {
      path: '/admin/general-settings',
      element: <AdminGeneralSettings />
    },
    {
      path: '/admin/reports',
      element: <AdminReports />
    }
  ]
};

export default MainRoutes;
